<template>
    <div>
        <div v-if="members && members.length > 0">
            <kgr-members-table
                v-if="view === 'list'"
                :members="members"
            />

            <kgr-members-grid
                v-if="view === 'grid'"
                :members="members"
            />
            <kgr-loading v-if="loading" />
            <div v-if="canLoadMore"
                 class="kgr-row kgr-row--inverse kgr-text--centered">
                <button
                    v-t="'Weitere Ergebnisse laden'"
                    class="kgr-button kgr-button--danger"
                    @click="$emit('loadMore')"
                ></button>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '../common/Loading';
import MembersGrid from './MembersGrid';
import MembersTable from './MembersTable';

export default {
    components: {
        'kgr-members-grid': MembersGrid,
        'kgr-members-table': MembersTable,
        'kgr-loading': Loading,
    },
    props: {
        members: {
            type: Array,
            required: false,
        },
        view: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
            default: false
        },
        canLoadMore: {
            type: Boolean,
            required: false,
            default: false
        }
    },
}
</script>
